import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const visions = ['Sabiendo exactamente cuánto ganás.', 'Entendiendo dónde se va tu dinero.', 'Tomando mejores decisiones.', 'Con más control financiero.', 'Con menos estrés.', 'Y con una estrategia clara para crecer.'];
export function Vision30Days() {
  return <section className="py-20 bg-navy-900 text-white relative overflow-hidden" data-id="element-393">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-50" data-id="element-394"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-395">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-396">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-397">
            IMAGINÁ TU NEGOCIO DENTRO DE 30 DÍAS
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-398">
          {visions.map((vision, index) => <motion.div key={index} className="flex items-center gap-4 bg-navy-800/50 p-4 rounded-xl border border-navy-700 backdrop-blur-sm" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-399">
              <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0" data-id="element-400" />
              <span className="text-lg font-medium" data-id="element-401">{vision}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}